import { render, staticRenderFns } from "./LaboratoryTest.vue?vue&type=template&id=f30acec0&scoped=true"
import script from "./LaboratoryTest.vue?vue&type=script&lang=js"
export * from "./LaboratoryTest.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryTest.vue?vue&type=style&index=0&id=f30acec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30acec0",
  null
  
)

export default component.exports